// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Reselect = require("../../../../shared/src/bindings/Reselect.bs.js");
var WebStore = require("../../store/WebStore.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_City = require("../../../../shared/src/types/CommonTypes_City.bs.js");
var WebGraphql_Signup = require("../../graphql/WebGraphql_Signup.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var WebStore_Selectors = require("../../store/WebStore_Selectors.bs.js");
var WebContainers_Signup_Business_VerifyCode = require("./WebContainers_Signup_Business_VerifyCode.bs.js");
var WebContainers_Signup_Business_BusinessInfo = require("./WebContainers_Signup_Business_BusinessInfo.bs.js");

function WebContainers_Signup_Business$Presentation(Props) {
  var checkIfEmailIsAvailable = Props.checkIfEmailIsAvailable;
  var checkIfPhoneNumberIsAvailable = Props.checkIfPhoneNumberIsAvailable;
  var cities = Props.cities;
  var layout = Props.layout;
  var view = Props.view;
  if (view.TAG === /* BusinessInfo */0) {
    return React.createElement(WebContainers_Signup_Business_BusinessInfo.make, {
                checkIfEmailIsAvailable: checkIfEmailIsAvailable,
                checkIfPhoneNumberIsAvailable: checkIfPhoneNumberIsAvailable,
                cities: cities,
                initialPromoCode: view.maybeReferralCode,
                layout: layout,
                utmParams: view.utmParams
              });
  } else {
    return React.createElement(WebContainers_Signup_Business_VerifyCode.make, {
                businessName: view.businessName,
                city: view.city,
                email: view.email,
                firstName: view.firstName,
                lastName: view.lastName,
                layout: layout,
                password: view.password,
                phoneNumber: view.phoneNumber,
                promoCode: view.promoCode,
                utmParams: view.utmParams
              });
  }
}

var Presentation = {
  make: WebContainers_Signup_Business$Presentation
};

var mapStateToProps = Reselect.createSelector3(undefined, (function (param) {
        return param.cities;
      }), WebStore_Selectors.getApolloClient, (function (param) {
        return param.layout;
      }), (function (cities, client, layout) {
        return {
                cities: Relude_Option.fold([], (function (param) {
                        return Relude_Globals.$great$great(Relude_Set.toArray, (function (param) {
                                      return Relude_Array.sortBy(CommonTypes_City.compareByName, param);
                                    }), param);
                      }), Relude_AsyncResult.getOk(cities)),
                client: client,
                layout: layout
              };
      }));

function mapDispatchToProps(_dispatch, param) {
  var client = param.client;
  return {
          checkIfEmailIsAvailable: (function (email) {
              return Curry._2(Relude_IO.mapError, (function (prim) {
                            
                          }), Curry._2(WebGraphql_Signup.CheckEmailAvailable.query, email, client));
            }),
          checkIfPhoneNumberIsAvailable: (function (phoneNumber) {
              return Curry._2(Relude_IO.mapError, (function (prim) {
                            
                          }), Curry._2(WebGraphql_Signup.CheckPhoneNumberAvailable.query, phoneNumber, client));
            })
        };
}

function WebContainers_Signup_Business(Props) {
  var view = Props.view;
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (param, param$1) {
                  return React.createElement(WebContainers_Signup_Business$Presentation, {
                              checkIfEmailIsAvailable: param$1.checkIfEmailIsAvailable,
                              checkIfPhoneNumberIsAvailable: param$1.checkIfPhoneNumberIsAvailable,
                              cities: param.cities,
                              layout: param.layout,
                              view: view
                            });
                })
            });
}

var make = WebContainers_Signup_Business;

exports.Presentation = Presentation;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* mapStateToProps Not a pure module */
